import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Common } from '../../shared/common';
import { Checkup } from 'src/app/models/Checkup';


@Component({
  selector: 'app-audit-history',
  templateUrl: 'audit-history.component.html',
  styleUrls: ['./audit-history.component.less', './../../shared/common.less'],
})

export class AuditHistoryComponent implements OnInit, OnChanges {
  @Input() audits: Array<Checkup>;
  @Input() auditSuccess: boolean;
  @Output() startAuditEvent = new EventEmitter<boolean>();
  @Output() reportDownload = new EventEmitter();
  filterValue: string = 'tous';
  filteredAudits: Array<Checkup> = [];

  constructor(private router: Router,
    public common: Common
  ) { }

  isAuditCompliant(integrity: boolean): string {
    if (integrity) {
      return 'Conforme';
    }
    return 'Non Conforme';
  }

  formatDate(date: string): string {
    if (!date) {
      return '';
    }
    return new Date(date).toLocaleString();
  }

  startAudit() {
    this.startAuditEvent.emit(true);
  }

  downloadReport() {
    this.reportDownload.emit();
  }

  auditType(type: string): string {
    if (type === 'organizer' || type === 'assessor') {
      return 'Manuel';
    } else {
      return 'Auto';
    }
  }

  onFilterChange() {
    if (!this.audits) {
      this.filteredAudits = [];
      return;
    }

    if (this.filterValue === 'tous') {
      this.filteredAudits = this.audits;
    } else if (this.filterValue === 'manuel') {
      this.filteredAudits = this.audits.filter(audit => audit.checkupType === 'organizer' || audit.checkupType === 'assessor');
    } else if (this.filterValue === 'auto') {
      this.filteredAudits = this.audits.filter(audit => audit.checkupType !== 'organizer' && audit.checkupType !== 'assessor');
    }
  }

  ngOnInit() {
    if (this.audits !== undefined) {
      this.onFilterChange();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['audits'] && this.audits) {
      this.onFilterChange();
    }
  }
}
